import React, { Fragment } from "react";
import styled from "styled-components";
import Check from "@material-ui/icons/Check";

import SecondaryButton from "./SecondaryButton";

const SaveButton = ({ onClick, ...other }) => (
  <SecondaryButton onClick={onClick} {...other}>
    <Check />
    <div>SAVE</div>
  </SecondaryButton>
);
export default SaveButton;
